import axios from "@/axios.js"

export default {

  viewGifts({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/getAdminGifts", data)
        .then((response) => {
          commit('SET_GIFT', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createGift({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createGift", data)
        .then((response) => {
          commit('ADD_GIFT', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateGift({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateGift", data)
        .then((response) => {
          commit('UPDATE_GIFT', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteGift({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteGift", data)
        .then((response) => {
          commit('DELETE_GIFT', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },


}
